import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { IBusinessCustomerCSVFormValues, IBusinessCustomerFormValues } from 'features/BusinessCustomer/types'

const messages = defineMessages({
  required: {
    id: 'businessCustomer.form.required',
    defaultMessage: 'This field is required'
  },
  max: {
    id: 'businessCustomer.form.max',
    defaultMessage: 'This field must be at most {max} characters'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IBusinessCustomerCSVFormValues> => {
  return yup.object().shape({
    file: yup.mixed().nullable(),
    filePath: yup.string().required(intl.formatMessage(messages.required)),
    customerType: yup.string().required(intl.formatMessage(messages.required)) as yup.SchemaOf<
      IBusinessCustomerFormValues['customerType']
    >,
    businessClient: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.required)),
      name: yup.string(),
      verticals: yup.array().of(yup.string())
    }) as yup.SchemaOf<IBusinessCustomerFormValues['businessClient']>,
    businessSite: yup.object().shape({
      id: yup.string(),
      name: yup.string()
    }) as yup.SchemaOf<IBusinessCustomerFormValues['businessSite']>
  })
}
